import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const AreaEmpreendimento = () => {
  const [areas, setAreas] = useState([]);
  const [filteredAreas, setFilteredAreas] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingArea, setEditingArea] = useState(null);
  const [formData, setFormData] = useState({
    nomeclatura: '',
    sigla: '',
    faixa: '',
    de: '',
    ate: '',
    ativo: true
  });

  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/area-empreendimento`);
        if (!response.ok) {
          throw new Error('Erro ao buscar áreas de empreendimento');
        }
        const data = await response.json();
        setAreas(data);
        setFilteredAreas(data);
      } catch (error) {
        console.error('Erro ao carregar áreas de empreendimento:', error);
      }
    };

    fetchAreas();
  }, []);

  const handleSearch = (term) => {
    setSearchTerm(term);
    const lower = term.toLowerCase();
    const filtered = areas.filter((area) =>
      (area.nomeclatura || '').toLowerCase().includes(lower) ||
      (area.sigla || '').toLowerCase().includes(lower) ||
      (area.faixa || '').toLowerCase().includes(lower)
    );
    setFilteredAreas(filtered);
  };

  // Abrir modal para nova área
  const handleNewArea = () => {
    setEditingArea(null);
    setFormData({
      nomeclatura: '',
      sigla: '',
      faixa: '',
      de: '',
      ate: '',
      ativo: true
    });
    setShowForm(true);
  };

  // Abrir modal para editar área
  const handleEdit = (area) => {
    setEditingArea(area);
    setFormData({
      nomeclatura: area.nomeclatura,
      sigla: area.sigla,
      faixa: area.faixa,
      de: area.de,
      ate: area.ate,
      ativo: area.ativo
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nomeclatura.trim() || !formData.sigla.trim() || !formData.faixa.trim()) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    const payload = {
      nomeclatura: formData.nomeclatura,
      sigla: formData.sigla,
      faixa: formData.faixa,
      de: formData.de === '' ? null : parseInt(formData.de, 10),
      ate: formData.ate === '' ? null : parseInt(formData.ate, 10),
      ativo: formData.ativo
    };

    try {
      if (editingArea) {
        const response = await fetch(
          `${API_BASE_URL}/area-empreendimento/${editingArea.id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar área de empreendimento');
        }

        const updated = await response.json();
        setAreas((prev) =>
          prev.map((area) => (area.id === editingArea.id ? updated : area))
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/area-empreendimento`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar área de empreendimento');
        }

        const created = await response.json();
        setAreas((prev) => [...prev, created]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar área de empreendimento:', error);
    }
  };

  // Resetar formulário
  const resetForm = () => {
    setFormData({
      nomeclatura: '',
      sigla: '',
      faixa: '',
      de: '',
      ate: '',
      ativo: true
    });
    setEditingArea(null);
    setShowForm(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta área?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/area-empreendimento/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir área de empreendimento');
      }

      setAreas((prev) => prev.filter((area) => area.id !== id));
    } catch (error) {
      console.error('Erro ao excluir área de empreendimento:', error);
    }
  };

  const handleToggleStatus = async (id) => {
    const areaAtual = areas.find((a) => a.id === id);
    if (!areaAtual) return;

    const updatedArea = {
      ...areaAtual,
      ativo: !areaAtual.ativo
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/area-empreendimento/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updatedArea)
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status da área de empreendimento');
      }

      const saved = await response.json();
      setAreas((prev) =>
        prev.map((a) => (a.id === id ? saved : a))
      );
    } catch (error) {
      console.error('Erro ao atualizar status da área de empreendimento:', error);
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Área do Empreendimento</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={handleNewArea}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Área
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingArea ? 'Editar Área do Empreendimento' : 'Cadastrar Área do Empreendimento'}</h2>
          </div>

          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nomeclatura">Nomenclatura *</label>
                <input
                  type="text"
                  id="nomeclatura"
                  value={formData.nomeclatura}
                  onChange={(e) =>
                    setFormData({ ...formData, nomeclatura: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="sigla">Sigla *</label>
                <input
                  type="text"
                  id="sigla"
                  value={formData.sigla}
                  onChange={(e) =>
                    setFormData({ ...formData, sigla: e.target.value })
                  }
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="faixa">Faixa *</label>
                <select
                  id="faixa"
                  value={formData.faixa}
                  onChange={(e) =>
                    setFormData({ ...formData, faixa: e.target.value })
                  }
                  required
                >
                  <option value="">Selecione a faixa</option>
                  {Array.from({ length: 26 }, (_, i) =>
                    String.fromCharCode(65 + i)
                  ).map((letter) => (
                    <option key={letter} value={letter}>
                      {letter}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="de">De</label>
                <input
                  type="number"
                  id="de"
                  value={formData.de}
                  onChange={(e) =>
                    setFormData({ ...formData, de: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="ate">Até</label>
                <input
                  type="number"
                  id="ate"
                  value={formData.ate}
                  onChange={(e) =>
                    setFormData({ ...formData, ate: e.target.value })
                  }
                />
              </div>
              <div className="form-group">
                <Toggle
                  id="ativo"
                  label="Status:"
                  checked={formData.ativo}
                  onChange={(e) =>
                    setFormData({ ...formData, ativo: e.target.checked })
                  }
                />
              </div>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={resetForm}
              >
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editingArea ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Buscar por nomenclatura, sigla ou faixa..."
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredAreas.length} registro(s) encontrado(s)</span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Nomenclatura</th>
                  <th className="col-sigla">Sigla</th>
                  <th>Faixa</th>
                  <th>De</th>
                  <th>Até</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredAreas.map(area => (
                  <tr key={area.id}>
                    <td>{area.id}</td>
                    <td>{area.nomeclatura}</td>
                    <td>{area.sigla}</td>
                    <td>{area.faixa}</td>
                    <td>{area.de}</td>
                    <td>{area.ate}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={area.ativo}
                          onChange={() => handleToggleStatus(area.id)}
                          id={`toggle-area-${area.id}`}
                        />
                      </div>
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => handleEdit(area)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(area.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredAreas.length === 0 && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <h3>Nenhuma área de empreendimento encontrada</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre uma nova área.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AreaEmpreendimento;
